import { createContext, useCallback, useContext, useEffect, useState } from "react";
import axios from "axios";
import { DEFAULT_PUBLIC_IMAGES, ARCHIVED_IMAGE_IDS } from "../data/imageLibrary";

const INITIAL = { overrides: {}, hidden: ARCHIVED_IMAGE_IDS, items: DEFAULT_PUBLIC_IMAGES };
const ImageContext = createContext({ ...INITIAL, refresh: async () => {} });
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const mediaSource = (image) => image.version ? `${API}/site-images/${image.id}/image?v=${encodeURIComponent(image.version)}` : image.original_url;

export const SiteImagesProvider = ({ children }) => {
    const [library, setLibrary] = useState(INITIAL);
    const refresh = useCallback(async () => {
        const { data } = await axios.get(`${API}/site-images`, { timeout: 20000 }); setLibrary(data); return data;
    }, []);
    useEffect(() => { refresh().catch(() => {}); }, [refresh]);
    return <ImageContext.Provider value={{ ...library, refresh }}>{children}</ImageContext.Provider>;
};
export const useSiteImages = () => useContext(ImageContext);

export const SiteImage = ({ assetId, src, webpSrc, alt, versionOverride, allowHidden = false, ...props }) => {
    const { overrides, hidden, items } = useSiteImages(); const [failed, setFailed] = useState("");
    const current = items.find((image) => image.id === assetId);
    const version = versionOverride || overrides[assetId];
    const replacement = version ? `${API}/site-images/${assetId}/image?v=${encodeURIComponent(version)}` : "";
    const active = replacement && failed !== replacement ? replacement : "";
    if (!allowHidden && hidden.includes(assetId)) return null;
    if (!active && !src) return <span className="media-image-unavailable" role="status" data-testid={props["data-testid"]}>Image unavailable<button type="button" onClick={() => setFailed("")} data-testid={`${props["data-testid"] || assetId}-retry`}>Retry</button></span>;
    return <img {...props} alt={alt} src={active || src} style={{ objectPosition: current?.object_position || "50% 50%", ...props.style }} onError={() => { if (active) setFailed(active); }} />;
};